<div
  id="product-reco-select-{{ index }}"
  class="product-recommendation-card"
  [ngClass]="{
    'product-outline': isSelected,
    'product-highlighted': isProductHighlighted,
    'product-notRecommended': isProductNotRecommended,
    'other-products': isOtherProductsSelectionCard,
    'product-selected': isSelected,
    'product-wet': isWetProduct,
  }"
>
  <rc-link
    id="product-reco-select-{{ index }}-btn"
    [attr.data-qa]="'vs-smart-recommendation-card-' + index + '-button-select'"
    class="product-recommendation-card__button"
    [attr.aria-labelledby]="productRecommendation?.product?.name?.replace(' ', '')"
    (click)="onSelectProduct(productRecommendation)"
  ></rc-link>

  @if (isOtherProductsSelectionCard) {
    <rc-link
      data-qa="vs-smart-recommendation-card-button-other-products"
      class="other-products-button"
      variant="secondary"
      size="large"
      (click)="showSearchProductPopin()"
    >
      <app-icon [name]="IconName.address_book"></app-icon>
      {{ 'sr-result-browse-product' | translateKey }}
    </rc-link>
  }
  @if (!!productRecommendation) {
    <div class="product-recommendation-card__content" [id]="'product-id-' + productRecommendation?.product?.id">
      @if (!isProductNotRecommendedOverlay && !isOtherProductsSelectionCard) {
        @let criterias = productRecommendation.coverage?.criterias;
        @let notRecommendedProductStatus = getNotRecommendedStatus();

        @if (isSelected) {
          <span class="product-recommendation-card__highlighted-icon">
            <app-icon [name]="IconName.success"></app-icon>
          </span>
        }
        @if (
          (isProductNotRecommended && notRecommendedProductStatus === NotRecommendedProductStatus.REQUIREMENTS_PARTIAL) ||
          atLeastNotRecommendedCriteria(criterias)
        ) {
          <span class="product-recommendation-card__warning-icon">
            <app-icon [name]="IconName.alert"></app-icon>
          </span>
        }
        <!-- Product details -->
        <ng-container>
          <div class="product-recommendation-card__header">
            <rc-link
              id="product-recommendation-details"
              data-qa="vs-smart-recommendation-card-button-details"
              variant="secondary"
              (click)="showDetailPopin(productRecommendation)"
              >{{ 'action_detail' | translateKey }}</rc-link
            >
            @if (isClinicalAllianceEnabled$ | async) {
              <app-clinical-alliance-badge [displayHeader]="productRecommendation.product.clinicalAlliance"></app-clinical-alliance-badge>
            }
          </div>
          <img
            class="product-recommendation-card__product-picture"
            [src]="productRecommendation.product.image | publicUrl: productRecommendation.product.productType"
            alt="{{ productRecommendation.product.name }}"
          />
          <p
            [id]="productRecommendation.product.name.replace(' ', '')"
            class="product-recommendation-card-title"
            [matTooltipPosition]="'below'"
            matTooltipClass="tooltip-arrow-up"
            matTooltipHideDelay="1"
            matTooltip="{{ productRecommendation.product.name }}"
            #tooltip="matTooltip"
          >
            {{ productRecommendation.product.name | truncate }}
          </p>
          <p class="product-recommendation-card__product-category">
            {{ productRecommendation.product.productType | translationCode: LocaleContentEnum.ProductType }}
          </p>
          <!-- Display product criterias for recommended product or not recommended products that at least partially meet requirements -->
          @if (criterias?.length) {
            <div class="product-recommendation-card__product-detail">{{ 'sr-result-nutritional-need' | translateKey }}</div>
            <ul class="product-recommendation-card__product-criterias">
              @for (criteria of criterias; track criteria.key) {
                <li class="product-recommendation-card__criteria">
                  @if (criteria.isNotRecommended) {
                    <span class="product-recommendation-card__criteria--not-recommended">Not recommended for this criteria</span>
                  } @else {
                    <app-rc-gauge
                      id="rc-gauge-{{ criteria.key }}"
                      [value]="roundSmartReco(criteria.pmean)"
                      [title]="getCriteriaTitle(criteria)"
                      [hasIcon]="true"
                    ></app-rc-gauge>
                  }
                </li>
              }
            </ul>
          }
          @let costPerDay = costPerDay$ | async;
          @if (!isWetProduct) {
            <div class="product-recommendation-card__costPerDay">
              @if (!!costPerDay) {
                <span> {{ costPerDay }}</span>
              }
            </div>
          }
          <!-- Action buttons for a not recommended product -->
          @if (isProductNotRecommended) {
            <div class="notRecommended-actions">
              <!-- Action buttons in case requirements are met -->
              <div>
                <rc-link
                  id="product-recommendation-remove"
                  data-qa="vs-smart-recommendation-card-button-remove"
                  variant="secondary"
                  size="large"
                  (click)="removeProduct()"
                >
                  {{ 'action-remove' | translateKey }}
                </rc-link>
              </div>
            </div>
          }
          <!-- Button to send feedback for a recommended product -->
          @if (!isProductNotRecommended && !isWetProduct) {
            <div class="product-recommendation-card__signal-button">
              <rc-link
                data-qa="vs-smart-recommendation-card-button-send-feedback"
                variant="secondary"
                size="large"
                (click)="openSignalPopin(productRecommendation)"
              >
                {{ 'sr-result-send-feedback' | translateKey }}
              </rc-link>
            </div>
          }
        </ng-container>
      }
    </div>
  }
</div>
@if (showNotRecommendedOverlay) {
  @let notRecommendedProductStatus = getNotRecommendedStatus();
  <div class="product-recommendation-card--overlay">
    @if (isProductNotRecommended && notRecommendedProductStatus === NotRecommendedProductStatus.REQUIREMENTS_KO) {
      <div class="product-recommendation-card--overlay--content notRecommended-ko-details">
        <div class="notRecommended-ko-details--title">
          <app-icon [name]="IconName.alert"></app-icon>
          <h4 i18n="@@information-mkt_filter">Information</h4>
        </div>
        <p>{{ 'sr_searchwarning_belowforty' | translateKey }}</p>
        <rc-link
          id="button-remove"
          data-qa="vs-smart-recommendation-card-button-remove"
          variant="secondary"
          size="large"
          (click)="removeProduct()"
        >
          {{ 'action-remove' | translateKey }}
        </rc-link>
      </div>
    } @else {
      <div class="product-recommendation-card--overlay--content notRecommended-mkf-explanations">
        <span class="notRecommended-mkf-explanations-title">
          <app-icon [name]="IconName.alert"></app-icon>
          <h4 i18n="@@information-mkt_filter">Information</h4>
        </span>
        <p class="notRecommended-mkf-explanations-warning" id="mkf-explanations-warning">
          {{ 'sr_searchwarning_betweenfortyandsixtyfour' | translateKey }}
        </p>
        @if (productRecommendation.notRecommendedReasons.includes(NotRecommendedReasons.TERRITORY)) {
          <p id="mkf-explanations-territory">
            {{ mkfTerritoryExplanation | async }}
          </p>
        }
        @if (productRecommendation.notRecommendedReasons.includes(NotRecommendedReasons.LIFESTAGE)) {
          <p id="mkf-explanations-lifestage">
            {{ mkfLifestageExplanation | async }}
          </p>
        }
        @if (productRecommendation.notRecommendedReasons.includes(NotRecommendedReasons.SIZE)) {
          <p id="mkf-explanations-size">
            {{ mkfSizeExplanation | async }}
          </p>
        }
        @if (productRecommendation.notRecommendedReasons.includes(NotRecommendedReasons.NEUTERED)) {
          <p id="mkf-explanations-neutered">
            {{ mkfNeuteredExplanation | async }}
          </p>
        }
        <rc-link
          id="product-recommendation-understand"
          data-qa="vs-smart-recommendation-card-button-understand"
          variant="secondary"
          size="large"
          (click)="hideNotRecommendedOverlay()"
        >
          {{ 'sr-understand' | translateKey }}
        </rc-link>
      </div>
    }
  </div>
}
